import { useState, useEffect } from 'react';
import { authService } from '../services/auth.service';

// Hook de autenticación con Firebase real
const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Escuchar cambios en el estado de autenticación
    const unsubscribe = authService.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        // Verificar dominio de Cromodata
        if (authService.isCromodataUser(firebaseUser)) {
          const customUser = {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            name: firebaseUser.displayName || firebaseUser.email.split('@')[0],
            photoURL: firebaseUser.photoURL,
            role: 'admin', // Por defecto admin
            createdAt: new Date().toISOString()
          };
          setUser(customUser);
        } else {
          // Usuario no autorizado
          setUser(null);
          authService.signOut();
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    // Limpiar suscripción al desmontar
    return () => unsubscribe();
  }, []);

  const signInWithGoogle = async () => {
    try {
      setLoading(true);
      const user = await authService.signInWithGoogle();
      setUser(user);
      return user;
    } catch (error) {
      console.error('Error en signInWithGoogle:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      await authService.signOut();
      setUser(null);
    } catch (error) {
      console.error('Error en signOut:', error);
      throw error;
    }
  };

  return { 
    user, 
    loading, 
    signInWithGoogle, 
    signOut,
    isAuthenticated: !!user 
  };
};

export default useAuth;
